export default {
  resources: {
    badge: 'Resources & Knowledge Hub',
    title: 'All resources',
    subtitle: 'Success stories, practical guides and industry insights to help you optimize delivery and fleet operations.',
    successStories: 'Success Stories',
    successStoriesSub: 'Real results from real delivery teams',
    learning: 'Learning',
    learningSub: 'Articles, whitepapers, and guides',
    stats: {
      caseStudies: 'Case studies',
      blogArticles: 'Blog articles',
      whitepapers: 'Whitepapers',
    },
    ctaTitle: 'Ready to see Geofleet in action?',
    ctaSubtitle: 'Get started or book a demo to get similar results for your operations.',
    ctaTrial: 'Get started',
    ctaDemo: 'Book a demo',
    explore: 'Explore',
    howItWorks: {
      title: 'How it works',
      subtitle: 'Simple to navigate, quick to find what you need',
    },
    whatsInside: {
      badge: "What you'll find",
      title: 'Everything {{name}} offers',
    },
    whyItMatters: {
      title: 'Why it matters',
      subtitle: 'Quick facts about {{name}}',
    },
    cta: {
      exploreTitle: 'Ready to explore {{name}}?',
      exploreSubtitle: 'Get started in minutes. Plans from $49 a month for 3 drivers.',
    },
  },
};
